export enum LiveRampCommands {
    AddEventListener = 'addEventListener',
    RemoveEventListener = 'removeEventListener'
}

type addLiveRampEventListenerCallback = (
    tcData: unknown,
    success: boolean
) => void;
type removeLiveRampEventListenerCallback = (result: boolean) => void;

export interface IWindowWithLiveRamp extends Window {
    __tcfapi: (
        command: LiveRampCommands,
        version: number | null,
        callback:
            | addLiveRampEventListenerCallback
            | removeLiveRampEventListenerCallback,
        parameter?: string
    ) => void;
}
